import { render, staticRenderFns } from "./GrupoMedicamento.vue?vue&type=template&id=19a14652"
import script from "./GrupoMedicamento.vue?vue&type=script&lang=ts"
export * from "./GrupoMedicamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports